import types from './types'
import { sortBy, cloneDeep, groupBy, values } from 'lodash'
import moment from 'moment'

function filteredPlanning (state, filter) {
  const actions = cloneDeep(state.planningitems).filter(filter)
  return sortBy(actions, x => x.period)
}

export default {
  [types.getters.byId]: (state) => (id) => {
    return state.planningitems.filter(x => x.key === id)[0]
  },
  [types.getters.byCultivation]: (state) => (id) => {
    return state.planningitems.filter(x => x.ID === id)
  },
  [types.getters.isSomePastDataLoaded]: (state) => {
    return state.planningitems.filter(x => x.period.isBefore(moment().startOf('day'))).length > 0
  },
  [types.getters.isAllDataLoaded]: (state, getters) => (selection) => {
    if (selection === 'date') return true
    if (selection === 'forgotten') selection = 'past'
    if (selection === 'cultivations') selection = 'all'
    if (state.lastItemKeys[selection] === 'empty') return true
    return state.planningitems.filter(x => x.key === state.lastItemKeys[selection]).length > 0
  },
  [types.getters.cultivations]: (state) => {
    const filter = x => x.period.isAfter(moment().startOf('day')) || x.done
    return values(groupBy(filteredPlanning(state, filter), x => x.ID))
  },
  [types.getters.all]: (state) => {
    return filteredPlanning(state, x => true)
  },
  [types.getters.past]: (state) => {
    const filter = x => x.period.isBefore(moment().startOf('day')) || x.done
    return filteredPlanning(state, filter).reverse()
  },
  [types.getters.forgotten]: (state) => {
    const filter = x => x.period.isBefore(moment().startOf('day')) && !x.done
    return filteredPlanning(state, filter).reverse()
  },
  [types.getters.coming]: (state) => {
    const filter = x => x.period.isSameOrAfter(moment().startOf('day')) && !x.done
    return filteredPlanning(state, filter)
  },
  [types.getters.comingWeek]: (state) => {
    const filter = x => x.period.isBefore(moment().add(7, 'days')) && x.period.isSameOrAfter(moment().startOf('day')) && !x.done
    return filteredPlanning(state, filter)
  },
  [types.getters.forDate]: (state) => (date) => {
    if (!date) return []
    const filter = x => moment(x.period).isSameOrAfter(date.startOf('day')) && moment(x.period).isSameOrBefore(date.endOf('day'))
    return filteredPlanning(state, filter)
  }
}
